import { render, staticRenderFns } from "./reviewThree.vue?vue&type=template&id=2ffadab0&"
import script from "./reviewThree.vue?vue&type=script&lang=js&"
export * from "./reviewThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports